module.exports = __webpack_public_path__ + "img/HBK3.png";